import React from 'react';
import { useTheme, IconButton } from '@material-ui/core';
import DataTableNativeML from '@/components/DataTableNativeML';
import { useSelector } from 'dva';
import { useLocation, history } from 'umi';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import TablesStyled from './TablesStyles';

export default ({
  keepParams,
  onClickDeleteGroup,
  handleEditClick,
  handleDownLoadClick,
}) => {
  const theme = useTheme();
  const location = useLocation();
  const { query } = location;
  const { pageNum = 1, pageSize = 10 } = query;
  const loadingEffect = useSelector((state) => state.loading);
  const loading =
    loadingEffect.effects['addAutoReplyRule/getMiniProgramAccountList'] ||
    loadingEffect.effects['miniQrCode/getQueryQrCodeGroupPage'];
  const pageData = { pageNum: Number(pageNum), pageSize: Number(pageSize) };
  const { hasNext, total, tableList } = useSelector(
    (state) => state.miniQrCode,
  );
  //小程序码分组表头
  const groupColumns = [
    {
      align: 'center',
      title: '小程序码组名称',
      id: 'name',
      width: '360',
    },
    {
      align: 'center',
      title: '小程序',
      id: 'appName',
      width: 'auto',
    },
    {
      align: 'center',
      title: '小程序码数量',
      id: 'count',
      width: '140',
    },
    {
      title: '操作',
      align: 'center',
      width: '240',
      render: (row) => {
        return (
          <div align="center" className="handle_btn">
            <ButtonTip title="详情">
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_miniprogram_qrcode_management_list_details',
                  events: ['_ev', '_ec'],
                  params: {
                    id: row.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  history.push({
                    pathname: '/miniapps/qr_code/qr_code_detail',
                    query: {
                      queryType: 'detail',
                      id: String(row.id),
                    },
                  });
                }}
              >
                <SvgIconML
                  name="detail"
                  size={24}
                  fill={theme.palette.primary.main}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip title="编辑">
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_miniprogram_qrcode_management_list_edit',
                  events: ['_ev', '_ec'],
                  params: {
                    id: row.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  handleEditClick(row);
                }}
              >
                <SvgIconML
                  name="edit"
                  size={24}
                  fill={theme.palette.primary.main}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip title="下载">
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_miniprogram_qrcode_management_list_download',
                  events: ['_ev', '_ec'],
                  params: {
                    id: row.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => handleDownLoadClick(row)}
              >
                <SvgIconML
                  name="downLoadFile"
                  size={24}
                  fill={theme.palette.primary.main}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip title="删除">
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_miniprogram_qrcode_management_list_delete',
                  events: ['_ev', '_ec'],
                  params: {
                    id: row.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  onClickDeleteGroup(row);
                }}
              >
                <SvgIconML
                  name="circleDelete"
                  size={24}
                  fill={theme.palette.primary.main}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
          </div>
        );
      },
    },
  ];

  //换页
  const changePage = (page) => {
    const newParams = {
      ...query,
      pageNum: page.pageNum,
      pageSize: page.pageSize,
    };
    keepParams && keepParams(newParams);
  };
  return (
    <TablesStyled theme={theme}>
      <DataTableNativeML
        columns={groupColumns}
        changePage={changePage}
        page={pageData}
        data={tableList || []}
        hasNext={hasNext}
        total={total}
        paging={true}
        columnKey="id"
        loading={loading}
      ></DataTableNativeML>
    </TablesStyled>
  );
};
